import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { optionsActions } from '../../actions';
import { FillMidjourneyParametersActionPayload } from '@bus/options/typedefs';

export function* parameters() {
  try {
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'midjourney/parameters' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillMidjourneyParametersActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(optionsActions.fillMidjourneyParameters(data));
  } catch (e) {
    yield handleError(e);
  }
}
